import React, { useContext } from 'react';
import { Modal, ModalContent, useDisclosure, Button, HStack, Text, VStack, Box, ModalOverlay } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from 'components/AccountContext';
import Visitante from '../../../images/dashboard/visitante.png';

function ModalLogin() {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const navigate = useNavigate();
  const { setUser } = useContext(AccountContext);
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent position="absolute" bottom="2em" w="90%" maxW="480px" borderRadius="1em">
          <Box w="50px" h="6px" bg="#E0E0E0" borderRadius="full" mx="auto" cursor="pointer" mt={4} onClick={onClose} />

          <VStack textAlign="center" p={6} spacing={6} align="center" bg="white" borderRadius="1em">
            <HStack>
              <Button bg="#5AB2AE" color="white" borderRadius="1em" p={2} _focus={false} onClick={() => navigate('/login')}>
                Já tenho conta
              </Button>
              <Button bg="#5AB2AE" color="white" borderRadius="1em" p={2} _focus={false} onClick={() => navigate('/cadastro')}>
                Criar nova conta
              </Button>
            </HStack>

            {/*
              <HStack align="center">
                <img src={Visitante} alt="Visitante" />
                <Text
                  color="#5AB2AE"
                  onClick={() => {
                    setUser((prev) => ({ ...prev, visitante: true }));
                    onClose();
                  }}
                  cursor="pointer"
                  fontWeight="semibold"
                >
                  Continuar como visitante
                </Text>
              </HStack>
            */}
          </VStack>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalLogin;
